import "core-js/modules/es6.string.link.js";
import "core-js/modules/es6.string.small.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-flex justify-content-lg-between position-relative col-12 p-0 container"
  }, [_c('div', {
    staticClass: "block",
    class: {
      'justify-content-center': !_vm.avatar || !_vm.tag1 && !_vm.cta
    }
  }, [_c('div', {
    class: {
      'block-text': _vm.avatar.small
    }
  }, [_vm.avatar.small ? _c('div', {
    staticClass: "d-flex align-items-end align-items-lg-center"
  }, [_vm.avatar.small ? _c('img', {
    staticClass: "img-fluid avatar rounded-circle mr-3",
    attrs: {
      "src": _vm.avatar.small,
      "data-srcset": _vm.avatar.small,
      "data-src": _vm.avatar.small,
      "data-sizes": "auto",
      "alt": _vm.avatar.alt
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_vm.avatarTitle ? _c('p', {
    staticClass: "mb-0 avatar-title font-weight-semibold"
  }, [_vm._v("\n            " + _vm._s(_vm.avatarTitle) + "\n          ")]) : _vm._e(), _vm._v(" "), _vm.avatarSubtitle ? _c('p', {
    staticClass: "text-secondary mb-0 d-none d-md-block"
  }, [_vm._v("\n            " + _vm._s(_vm.avatarSubtitle) + "\n          ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm.tag1 || _vm.tag2 ? _c('div', {
    staticClass: "d-flex mb-3",
    class: {
      'mt-4': _vm.avatar.small
    }
  }, [_vm.tag1 ? _c('small', {
    staticClass: "tag font-weight-semibold mr-2"
  }, [_vm._v("\n          " + _vm._s(_vm.tag1) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm.tag2 ? _c('small', {
    staticClass: "tag font-weight-semibold"
  }, [_vm._v("\n          " + _vm._s(_vm.tag2) + "\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.title && _vm.title[0].text ? _c('RegularTitle', {
    staticClass: "font-weight-semibold title mb-0",
    attrs: {
      "text": _vm.title[0].text,
      "level": _vm.title[0].type
    }
  }) : _vm._e(), _vm._v(" "), _vm.description.length > 0 ? _c('SimpleParagraph', {
    staticClass: "d-none d-sm-block paragraph mt-2",
    attrs: {
      "paragraph": _vm.description,
      "has-margin": false
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm.cta ? _c('div', {
    staticClass: "mt-0 mt-md-4 cta"
  }, [_c('a', {
    class: _vm.ctaClasses,
    attrs: {
      "href": _vm.link.url,
      "target": _vm.link.target
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("\n        " + _vm._s(_vm.cta) + "\n      ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "media ml-auto"
  }, [_vm.hasBeforeAfterEffect ? _c('div', {
    staticClass: "wrapper-before-after"
  }, [_c('BeforeAfterImages', {
    attrs: {
      "image-before": _vm.imageBefore,
      "image-after": _vm.imageAfter,
      "label-image-before": _vm.labelImageBefore,
      "label-image-after": _vm.labelImageAfter
    }
  })], 1) : _vm._e(), _vm._v(" "), !_vm.hasBeforeAfterEffect && _vm.image ? [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.image.large,
      "alt": _vm.image.alt,
      "data-sizes": "auto"
    }
  })] : _vm._e()], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };